"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dInteractionHandler = void 0;
const rc_js_util_1 = require("rc-js-util");
const pinch_zoom_handler_cartesian2d_1 = require("./pinch-zoom-handler-cartesian2d");
const core_1 = require("@visualization-tools/core");
const cartesian_user_interaction_transform_provider_1 = require("./cartesian-user-interaction-transform-provider");
/**
 * @public
 * Default interaction handler for cartesian 2d. Allows panning, zooming with mouse and touch events like pinch zoom.
 * Ranges are restricted to avoid float precision issues, see {@link Cartesian2dFloatPrecisionRangeBounder}.
 */
class Cartesian2dInteractionHandler {
    constructor(chart, plot, listeners) {
        this.chart = chart;
        this.plot = plot;
        this.pinchZoomHandler = new pinch_zoom_handler_cartesian2d_1.PinchZoomHandlerCartesian2d(this.plot, this.chart.attachPoint.canvasDims, rc_js_util_1.Vec2.f32.factory.createOneEmpty(), 0);
        this.userCallbacks = new core_1.UserEventHandlerCallbacks(listeners);
        this.tmpRange2d = plot.plotRange.dataRange
            .slice()
            .fill(0);
        this.userTransformProvider = new cartesian_user_interaction_transform_provider_1.CartesianUserInteractionTransformProvider(plot);
    }
    onEntityRequiresUpdate(updateFlag) {
        core_1.OnPlotRequiresUpdate.emit(this.plot, updateFlag);
    }
    onCanvasResized() {
        // no action needed
    }
    onClick(targets, $event) {
        this.userCallbacks.onClick(targets, $event);
    }
    onDoubleClick(targets, $event) {
        this.userCallbacks.onDoubleClick(targets, $event);
    }
    onHover(hoverResult, $event) {
        this.userCallbacks.onHover(hoverResult, $event);
    }
    onDragStart(targets, $event) {
        return this.userCallbacks.onDragStart(targets, $event);
    }
    onDragEnd($event) {
        this.userCallbacks.onDragEnd($event);
    }
    onDrag($event) {
        this.userCallbacks.onDrag($event);
    }
    onPan($event, dx, dy) {
        const plotRange = this.plot.plotRange;
        const dd = this.userTransformProvider.getTransformedDelta($event.pointerCssPosition, this.plot.plotDimensionsOBL.pixelArea.interactiveRange, dx, dy);
        this.tmpRange2d.set(plotRange.dataRange);
        this.tmpRange2d.translateBy(dd.getX(), dd.getY());
        plotRange.updateDataRange(this.tmpRange2d);
        this.userCallbacks.onPan($event, dx, dy);
        this.chart.updateOnNextFrame(this.plot);
    }
    onPanZoomStart(cssCenterPoint, width) {
        this.pinchZoomHandler = new pinch_zoom_handler_cartesian2d_1.PinchZoomHandlerCartesian2d(this.plot, this.chart.attachPoint.canvasDims, cssCenterPoint.slice(), width);
    }
    onPanZoomChange($event, centerPoint, distanceBetweenPoints) {
        this.pinchZoomHandler.onPanZoomChange(centerPoint, distanceBetweenPoints);
        this.userCallbacks.onPanZoomChange($event, centerPoint, distanceBetweenPoints);
        this.chart.updateOnNextFrame(this.plot);
    }
    onWheel($event, dz) {
        // ut - user transform
        const plotRange = this.plot.plotRange;
        const utDataPosition = this.userTransformProvider.getTransformedPosition($event.pointerClipPosition, this.plot.plotDimensionsOBL.clipSpaceArea.interactiveRange);
        this.tmpRange2d.set(plotRange.transformedDataRange);
        this.tmpRange2d.scaleRelativeTo(1 - dz * 0.001, utDataPosition, this.tmpRange2d);
        plotRange.userTransform.reverseTransformRange(this.tmpRange2d, this.tmpRange2d);
        this.tmpRange2d.bound(plotRange.maxBounds);
        plotRange.updateDataRange(this.tmpRange2d);
        this.userCallbacks.onWheel($event, dz);
        this.chart.updateOnNextFrame(this.plot);
    }
}
exports.Cartesian2dInteractionHandler = Cartesian2dInteractionHandler;
//# sourceMappingURL=cartesian2d-interaction-handler.js.map